module.exports = __webpack_public_path__ + "8a8a4ebd32b05d3e5737db036795649d.png";